import { PricingTargetType } from 'app/shared/modules/PricingWorkbench/PricingWorkbench.constants';

export const PrepaymentPenaltyFeatureType = {
  REQUIRED: 'Required',
  NOT_OFFERED: 'NotOffered',
  OPTIONAL: 'Optional',
};

export const OriginationFeeType = {
  RATE: 'Rate',
  FLAT: 'Flat',
};

export const DocMagicPlanCodeType = {
  DSI_CONV: 'DSI_CONV',
  DSI_TX6: 'DSI_TX6',
  CONVNB: 'CONVNB',
  SIX_MOLIB: '6MOLIB',
};

export const ProgramFilterType = {
  LOAN_TYPE: 'loanType',
  AMORTIZATION_TYPES: 'amortizationTypes',
  LOAN_TERM: 'loanTerm',
  LOCK_TERM: 'lockTerm',
  INVESTOR: 'investorIds',
  DESIRED_TARGET_TYPE: 'desiredTargetType',
  DESIRED_TARGET_VALUE: 'desiredTargetValue',
};

export const DesiredTargetSearchFilterKey = {
  [PricingTargetType.RATE]: 'desiredRate',
  [PricingTargetType.PRICE]: 'desiredPrice',
};

export const DesiredTargetMaxValue = {
  [PricingTargetType.RATE]: 100,
  [PricingTargetType.PRICE]: 200,
};

export const BEST_PRICING_INVESTOR_VALUE = 'BEST_PRICING';
export const BEST_PRICING_INVESTOR_OPTION = {
  label: 'Best Pricing',
  value: BEST_PRICING_INVESTOR_VALUE,
  isExclusive: true,
};

const ALL_INVESTORS_VALUE = 'ALL_INVESTORS';
export const ALL_INVESTORS_OPTION = {
  label: 'All Investors',
  value: ALL_INVESTORS_VALUE,
  isSelectAll: true,
};

export const LoanProgramsFilterIds = {
  [ProgramFilterType.LOAN_TYPE]: 'program.programLoanType',
  [ProgramFilterType.AMORTIZATION_TYPES]: 'amortizationType',
  [ProgramFilterType.LOAN_TERM]: 'loanPeriod',
  [ProgramFilterType.LOCK_TERM]: 'selectedRateLockTerm',
};

export const programFiltersIds = [ProgramFilterType.LOAN_TYPE, ProgramFilterType.LOCK_TERM];

export const EXECUTION_TYPE = {
  BEST_EX: 'BestEx',
  CASH: 'Cash',
  MBS: 'MBS',
};

export const RateType = {
  FIXED: 'Fixed',
  VARIABLE: 'Variable',
};

export const AmortizationType = {
  INTEREST_ONLY: 'InterestOnly',
  FULLY_AMORTIZED: 'FullyAmortized',
};

export const LoanProgramAmortizationType = {
  FIXED: 'Fixed',
  ARM: 'ARM',
};

export const MinimumInitialDrawType = {
  LINE_LIMIT_PERCENTAGE: 'LineLimitPercentage',
  CURRENCY_AMOUNT: 'CurrencyAmount',
};

export const PROGRAM_FILTERS_GROUP_ID = 'loanProgramOptions';

export const SearchFilterConfigurationStatus = {
  LOADING: 'Loading',
  LOADED: 'Loaded',
  FAILED: 'Failed',
};

export const FormPopulationOption = {
  MAY_HAVE_PREPAYMENT_PENALTY: 'MayHavePrepaymentPenalty',
  WILL_NOT_HAVE_TO_PAY: 'WillNotHaveToPayAPenalty',
  WILL_NOT_BE_ENTITLED_TO_REFUND: 'WillNotBeEntitledToARefundOfPartOfTheFinanceCharge',
};

export const AssumableDetailsOption = {
  MAY: 'May',
  MAY_SUBJECT_TO_CONDITIONS: 'MaySubjectToConditions',
  MAY_NOT_ASSUME_REMAINDER_OF_LOAN: 'MayNotAssumeRemainderOfLoan',
};

export const AffordableProductType = {
  HOME_READY: 'HomeReady',
  HFA_PREFERRED: 'HfaPreferred',
};

export const LoanOptionPriceStatus = {
  AVAILABLE: 'Available',
  SUSPENDED: 'Suspended',
  EXPIRED: 'Expired',
  TODAYS_PRICING_EXPIRED: 'TodaysPricingExpired',
};

export const TBD_AFTER_SAVE = 'TBD after save';

export const LoanProgramFieldName = {
  PROGRAM_CODE: 'lpProgramCode',
  PROGRAM_LOAN_TYPE: 'lpProgramLoanType',
  LOAN_TERM: 'lpLoanTerm',
  AMORT_TERM: 'lpAmortTerm',
  AMORTIZATION_TYPE: 'lpAmortizationType',
  INTEREST_ONLY_PERIOD: 'lpInterestOnlyPeriod',
  BALLOON_TERM_MONTHS: 'lpBalloonTermMonths',
  ARM_INITIAL_CAP: 'lpArmInitialCap',
  ARM_ADJUSTMENT_CAP: 'lpArmAdjustmentCap',
  ARM_SUBSEQUENT_CAP: 'lpArmSubsequentCap',
  ARM_RATE_ADJ_PERIOD: 'lpArmRateAdjPeriod',
  ARM_SUB_RATE_ADJ_PERIOD: 'lpArmSubRateAdjPeriod',
  ARM_FLOOR_RATE: 'lpArmFloorRate',
  ARM_CEILING_RATE: 'lpArmCeilingRate',
  ARM_ADJ_CHANGE_INDEX_RATE: 'lpArmAdjChangeIndexRate',
  INDEX_TYPE_ID: 'lpIndexTypeId',
  INDEX_MARGIN: 'lpIndexMargin',
  INDEX_RATE: 'lpIndexRate',
  INDEX_PERIOD_DAYS: 'lpIndexPeriodDays',
  PREPAY_FEATURE_TYPE: 'lpPrepayFeatureType',
  PREPAY_MONTHS_IN_AFFECT: 'lpPrepayMonthsInAffect',
  PREPAY_CHARGE_TERM_MONTHS: 'lpPrepayChargeTermMonths',
  PREPAY_CHARGE_RATE: 'lpPrepayChargeRate',
  PREPAY_MAX_AMOUNT: 'lpPrepayMaxAmount',
  PREPAY_DESCRIPTION: 'lpPrepayDescription',
  ANNUAL_FEE: 'lpAnnualFee',
  MONTHLY_FEE: 'lpMonthlyFee',
  INIT_DRAW_PERIOD: 'lpInitDrawPeriod',
  INIT_DRAW_MIN_TYPE: 'lpInitDrawMinType',
  INIT_DRAW_MIN_PERCENT: 'lpInitDrawMinPercent',
  INIT_DRAW_MIN_AMOUNT: 'lpInitDrawMinAmount',
  INIT_DRAW_AMORT_TYPE: 'lpInitDrawAmortType',
  INIT_DRAW_VAR_RATE_TYPE: 'lpInitDrawVarRateType',
  REPAY_PERIOD: 'lpRepayPeriod',
  REPAY_TYPE: 'lpRepayType',
  INIT_DRAW_VARIABLE_RATE: 'lpInitDrawVariableRate',
  REPAY_VARIABLE_RATE: 'lpRepayVariableRate',
  CHAR_ARM: 'lpCharArm',
  CHAR_ASSUMABLE: 'lpCharAssumable',
  CHAR_CONFORMING: 'lpCharConforming',
  CHAR_COUNSELING_REQUIRED: 'lpCharCounselingRequired',
  CHAR_INTEREST_ONLY: 'lpCharInterestOnly',
  CHAR_HAS_PREPAY_PENALTY: 'lpCharHasPrepayPenalty',
  CHAR_RUN_AUS: 'lpCharRunAus',
  CHAR_AFFORDABLE_LENDING: 'lpCharAffordableLending',
  CHAR_TEXAS_CASH_OUT: 'lpCharTexasCashOut',
  CHAR_DEMAND_FEATURE: 'lpCharDemandFeature',
  CHAR_NEG_AMORT: 'lpCharNegAmort',
  CHAR_BALLOON_PAYMENT: 'lpCharBalloonPayment',
  CHAR_BRIDGE_LOAN: 'lpCharBridgeLoan',
  CHAR_CONSTRUCTION_ONLY: 'lpCharConstructionOnly',
  CHAR_MORE_THAN_2_PAYMENTS: 'lpCharMoreThan2Payments',
  CHAR_INTEREST_INCREASED: 'lpCharInterestIncreased',
  CHAR_DEMAND_CLAUSE: 'lpCharDemandClause',
  CHAR_LENDER_PAID_MI: 'lpCharLenderPaidMI',
  ASSUMABLE_DETAILS: 'lpAssumableDetails',
};
